import type { LandingAssetsContent, LandingStepsContent } from "../types";

export const landingSteps: LandingStepsContent = {
  title: { lead: "Vier Schritte. ", highlight: "Keine Überraschungen." },
  ctaFullGuide: "Vollständigen Ablauf ansehen",
  stepLabel: "SCHRITT",
  steps: {
    chooseAccount: {
      title: "Konto wählen",
      sub: "Einmalige Gebühr. Fünf Größen. Zwei Evaluationsmodelle.",
      // [de-review] States the price range and both evaluation models.
      body: "Wähle aus fünf finanzierten Stufen (10.000 $ bis 200.000 $) und dem Evaluationsmodell, das zu deinem Stil passt. 1-Phase ist ein einphasiger Weg mit strengeren Risikoregeln. 2-Phasen teilt die Evaluation in zwei konservativere Phasen. Einmal zahlen und loslegen.",
      bullets: ["Kein Abo, keine versteckten Gebühren", "Fünf Größen · zwei Evaluationsmodelle"],
    },
    passEvaluation: {
      title: "Evaluation bestehen",
      sub: "Ziel erreichen. Limits einhalten.",
      body: "Jede Regel ist vorab dokumentiert und wird in beiden Modellen konsequent angewendet. Erreiche das Gewinnziel und bleibe dabei innerhalb der Drawdown- und Risikolimits. Kein Zeitdruck.",
      // [de-review] Carries the drawdown limits verbatim. The figures are the
      // risk rules a trader is held to — they must match the English exactly.
      bullets: [
        "Kein Zeitlimit für die Evaluation",
        "Drawdown: 4 % / 7 % (1-Phase) · 5 % / 10 % (2-Phasen)",
      ],
    },
    getFunded: {
      title: "Finanziert werden",
      sub: "Live MT5. Institutionelle Ausführung.",
      body: "Sobald du bestehst, wirst du für ein finanziertes Konto auf MetaTrader 5 freigeschaltet. Orders werden per STP-Ausführung direkt an den Markt geleitet, gestützt auf institutionelle Liquiditätsanbieter. Dieselbe Infrastruktur, die professionelle Desks nutzen.",
      // "MetaTrader 5" is a product name and stays identical.
      bullets: ["MetaTrader 5", "STP-Ausführung · institutionelle Liquidität"],
    },
    withdrawShare: {
      title: "Anteil auszahlen",
      sub: "80 % Basis-Split. Feste Auszahlungsfenster.",
      // [de-review] The payout promise and the split ceiling.
      body: "Finanzierte Trader stellen Auszahlungsanträge in festen monatlichen Fenstern. Jedes Konto startet mit einem 80-%-Split. Höhere Splits werden über den Skalierungsplan oder das optionale Split-Add-on beim Checkout freigeschaltet.",
      bullets: ["80 % Basis-Split · bis zu 90 %", "Banküberweisung oder USDC / USDT"],
    },
  },
};

export const landingAssets: LandingAssetsContent = {
  title: { lead: "300+ Instrumente. ", highlight: "Ein Konto." },
  ctaFullList: "Vollständige Asset-Liste",
  // Direction glyphs plus a two-letter abbreviation; "UP"/"DN" become the German
  // "AUF"/"AB" so the badge reads as a word rather than an English fragment.
  up: "▲ AUF",
  down: "▼ AB",
  categories: {
    // "Forex" and "Krypto" are the terms German traders use; the instrument
    // shorthand lists (SPX, XAU, BTC…) are tickers and stay identical.
    forex: { name: "Forex", countUnit: "Paare", description: "Maj / Min / Exotisch" },
    indices: { name: "Indizes", countUnit: "Indizes", description: "SPX, NDX, DAX" },
    metals: { name: "Metalle", countUnit: "Metalle", description: "XAU, XAG, XPT" },
    crypto: { name: "Krypto", countUnit: "Paare", description: "BTC, ETH, SOL" },
    energies: { name: "Energie", countUnit: "Energieträger", description: "WTI, BRENT, NG" },
  },
};
